import type { FC } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { Container } from "./components/Container";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";

export const ErrorBoundary: FC = () => {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const title = status === 404 ? "ページが見つかりませんでした" : "予期しないエラーが発生しました";
  const description =
    status === 404
      ? "お探しのページは削除されたか、URL が変更された可能性があります。"
      : "しばらくしてから再度お試しください。問題が続く場合はお問い合わせください。";

  return (
    <div className="flex min-h-screen flex-col bg-white text-neutral-900 antialiased">
      <SiteHeader showLogout={false} />
      <main className="flex-1">
        <Container>
          <p className="mb-4 text-neutral-500 text-xs">{status}</p>
          <h1 className="mb-3 font-medium text-2xl tracking-tight">{title}</h1>
          <p className="mb-8 text-neutral-500 text-sm">{description}</p>
          <Link to="/" className="text-sm underline underline-offset-4 hover:text-neutral-900">
            マイページのトップに戻る
          </Link>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
};
